import React from 'react';
import {appHost} from '@/config';
import {useTranslation} from 'react-i18next';

const MainSiteLink = ({children, href, ...props}) => {
  const {i18n: i18nCtx} = useTranslation();

  return (
    <a href={`${appHost}/${i18nCtx.language}/${href}`} {...props}>
      {children}
    </a>
  );
};

export default MainSiteLink;
